import React, { useEffect, useRef } from 'react';
import './UIReimagine.css';
import {Link} from 'react-router-dom';

const cards = [
  {
    id: 1,
    title: 'EDUCATION',
    desc: 'From e-learning platforms to student management systems, empower your educational institutions to deliver seamless and immersive learning experiences and embrace the future of education.',
    bg: '/images/education.avif',
  },
  {
    id: 2,
    title: 'HOSPITALITY & LEISURE',
    desc: 'Navigate the digital transformation journey with online booking platforms to travel itinerary apps. Enhance the traveler’s journey and elevate your services in the competitive travel landscape.',
    bg: '/images/hospitality.avif',
  },
  {
    id: 3,
    title: 'TECHNOLOGY',
    desc: 'Whether its developing SaaS platforms or optimizing customer satisfaction, create tech solutions that not only set you apart but are also pivotal for your digital transformation journey.',
    bg: '/images/technology.avif',
  },
];

const ReimagineSection = () => {
  const refs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    refs.current.forEach(ref => ref && observer.observe(ref));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="reimagine-section">
      <div className="container">
      <div className="reimagine-header72">
        <h2 className="fade-left" ref={el => refs.current[0] = el}>
          WE HELP <span className="blue">REIMAGINE INDUSTRIES</span>
        </h2>
        <p className="fade-right" ref={el => refs.current[1] = el}>
          Explore how we partner with businesses across domains to create next-gen digital experiences that lead change.
        </p>
      </div>

      <div className="reimagine-cards">
        {cards.map((card, i) => (
          <div
            className="reimagine-card72 fade-up"
            key={card.id}
            ref={el => refs.current[i + 2] = el}
            style={{ backgroundImage: `url(${card.bg})` }}
          >
            <div className="card-overlay5462">
              <h3 className="card-title5462">{card.title}</h3>
              <div className="card-hover-content5462">
                <p>{card.desc}</p>
                <span className="explore-arrow">→ EXPLORE</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="reimagine-btn">
        <Link to="/industries">
        <button>SEE ALL INDUSTRIES</button>
        </Link>
      </div>
      </div>
    </section>
  );
};

export default ReimagineSection;
